// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WBt8E","skeleton-animation":"styles_skeleton-animation__gX9Sk"};